<script setup lang="ts">
import { usePopupManager } from "@/shared/composables/usePopupManager";
import Close from "@/shared/components/svgs/Close.vue";
import type { BasePopupProps } from "@/shared/plugins/interface";

const props = defineProps<BasePopupProps>();

const { closePopup } = usePopupManager();

const clickConfirmButton = () => {
    if (props.rest.closeCallback) {
        props.rest.closeCallback();
    }
    closePopup(props.closeKey);
};
</script>

<template>
    <div class="relative px-[2rem] pb-[2rem] pt-[2.8rem] sm:size-full w-dvw h-dvh sm:max-h-[75rem]">
        <div class="w-full flex flex-col items-start justify-center gap-[1.5rem] mb-[1.6rem]">
            <h2 class="text-lg font-semibold font-pretended text-primary-black">
                {{ rest.title }}
            </h2>
            <div class="w-full h-[0.1rem] bg-custom-border-gray"></div>
        </div>
        <div class="size-full">
            <component :is="props.innerComponent" v-bind="props.rest" />
        </div>
        <div
            class="absolute right-8 top-12 cursor-pointer sm:right-1 sm:top-3 size-fit"
            @click="clickConfirmButton"
        >
            <Close />
        </div>
    </div>
</template>

<style lang="scss" scoped></style>
